webpackJsonp([14],{

/***/ 734:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__ = __webpack_require__(776);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_437b3430_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__ = __webpack_require__(819);
var normalizeComponent = __webpack_require__(105)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_437b3430_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 776:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_institution__ = __webpack_require__(368);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: '',
      institutions: [],
      employees: [],
      employeeSelected: null
    };
  },

  computed: {
    user: function user() {
      return this.$auth.user();
    },
    countEmployees: function countEmployees() {
      var _this = this;

      var count = 0;
      this.employees.map(function (employee) {
        if (employee.employee_code !== _this.$auth.user().employee_code) count++;
      });
      return count;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    setNavigatorLinks: 'navigator/setLinks',
    setNavigatorTitle: 'navigator/setTitle',
    setLinks: 'navigator/setLinks',
    setFineplay: 'navigator/setFineplay'
  }), {
    handleClickInstitution: function handleClickInstitution(institution) {
      this.$router.push({ name: 'institutions.show', params: { institutionCode: institution.institution_code } });
    },
    handleClickEmployee: function handleClickEmployee(employee) {
      this.setLinks([{ title: '' + employee.display_name, route: { name: 'home' } }]);
      this.employeeSelected = employee;
      this.employees = [];
      this.institutions = [];
      document.getElementsByClassName('search_result')[0].scrollTo(0, 0);
    },
    submit: function submit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var loading, params, instRes, empRes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.employeeSelected = null;
                loading = _this2.$loading.show();

                _this2.$router.replace({ query: { search: _this2.search } });
                params = { search: _this2.search };
                _context.prev = 4;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_4__api_institution__["a" /* default */].search(params);

              case 7:
                instRes = _context.sent;

                _this2.institutions = instRes.data.data;
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](4);

                console.log(_context.t0);

              case 14:
                _context.prev = 14;
                _context.next = 17;
                return __WEBPACK_IMPORTED_MODULE_4__api_institution__["a" /* default */].employeesSearch(params);

              case 17:
                empRes = _context.sent;

                _this2.employees = empRes.data.data;
                _context.next = 24;
                break;

              case 21:
                _context.prev = 21;
                _context.t1 = _context['catch'](14);

                console.log(_context.t1);

              case 24:
                loading.hide();

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4, 11], [14, 21]]);
      }))();
    },
    handleClickCloseBtn: function handleClickCloseBtn() {
      this.$router.push({ name: 'home' });
    }
  }),
  mounted: function mounted() {
    this.setNavigatorLinks([]);
    this.setNavigatorTitle('チャット');
    this.setFineplay(false);
    this.search = this.$route.query.search;
    document.getElementById('institutions_search_input').focus();
  }
});

/***/ }),

/***/ 819:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home_page"},[_c('div',{staticClass:"search_form focus"},[(!_vm.employeeSelected)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],attrs:{"id":"institutions_search_input","type":"search"},domProps:{"value":(_vm.search)},on:{"change":_vm.submit,"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"icon_close",on:{"click":_vm.handleClickCloseBtn}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_result"},[_c('div',{staticClass:"items_list white"},[(_vm.institutions.length > 0)?_c('div',{staticClass:"item item-header"},[_c('span',{staticClass:"icon-search"}),_vm._v(" "),_c('span',{staticClass:"text"},[_c('strong',[_vm._v("施設: "+_vm._s(_vm.institutions.length)+"件")])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.institutions),function(item){return _c('div',{key:item.institution_code,staticClass:"item",on:{"click":function($event){return _vm.handleClickInstitution(item)}}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(item.official_name_kanji))])])}),_vm._v(" "),(_vm.countEmployees > 0)?_c('div',{staticClass:"item item-header"},[_c('span',{staticClass:"icon-search"}),_vm._v(" "),_c('span',{staticClass:"text"},[_c('strong',[_vm._v("担当者: "+_vm._s(_vm.countEmployees)+"件")])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.employees),function(item){return (item.employee_code !== _vm.user.employee_code)?_c('div',{key:item.institution_code,staticClass:"item",on:{"click":function($event){return _vm.handleClickEmployee(item)}}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(item.name_kanji))])]):_vm._e()})],2),_vm._v(" "),(_vm.employeeSelected)?_c('div',{staticClass:"items_list white employee_selected_institutions"},[_c('div',{staticClass:"item"},[_c('span',{staticClass:"text"},[_c('strong',[_vm._v(_vm._s(_vm.employeeSelected.name_kanji))])])]),_vm._v(" "),_vm._l((_vm.employeeSelected.institutions),function(item){return _c('div',{key:item.institution_code,staticClass:"item",on:{"click":function($event){return _vm.handleClickInstitution(item)}}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(item.official_name_kanji))])])})],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/14.eef812cbaebcb8a75bae.js